const state= {

};

const getters = {
    
};

const actions = {
    // preview
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/pa/preview-data-entry`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // data entry header
    async getEntryHeader({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/pa/data-entry-header`, {params: params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // data entry header
    async getEntryHeaderID({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/pa/data-entry-header/${params}`)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // create entry header
    async createEntryHeader({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/pa/data-entry`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // pa report
    async getPAReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/pa/report/`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createDataEntriesOtherSource({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();

            formData.append("type", params.type);
            formData.append("month", params.month);
            formData.append("year", params.year);
            formData.append("contract_id", params.contract_id || '' );
            formData.append("property_type", params.property_type || '' );
            //formData.append("items", params.items || '' );
            if(params.items && params.items.length > 0){
                for( var i = 0; i < params.items.length; i++ ){
                    let items = params.items[i];
                    formData.append('items['+ i +'][property_id]', items.property_id);
                    formData.append('items['+ i +'][property_name]', items.property_name);
                    formData.append('items['+ i +'][data_from_iems]', items.data_from_iems);
                    formData.append('items['+ i +'][feedback_from_rc]', items.feedback_from_rc);
                    formData.append('items['+ i +'][feedback_from_sm]', items.feedback_from_sm);
                    formData.append('items['+ i +'][total_weight]', items.total_weight);
                    formData.append('items['+ i +'][max_weight]', items.max_weight);
                    formData.append('items['+ i +'][id]', items.id || '');
                    if(items.attachmentAdd && items.attachmentAdd.length > 0){
                        for( var z = 0; z < items.attachmentAdd.length; z++ ){
                            let photo = items.attachmentAdd[z];
                            formData.append('photos['+ i +']['+z+']', photo);
                            formData.append('file_titles['+ i +']['+z+']', photo.image_file_title || '');
                        }
                    }
                    if(items.attachmentDelete && items.attachmentDelete.length > 0){
                        for( var j = 0; j < items.attachmentDelete.length; j++ ){
                            let photoD = items.attachmentDelete[j];
                            if(photoD.id) formData.append('photosDelete['+i+'][' + j + ']', photoD.id);
                        }
                    }
                }
            }
            global.axios.post(`api/pa/data-entry`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
    // export report
    async exportPAReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/report/`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    // export report
    async exportInterimReportReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/report/`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    // export excel
    async exportInterimReportExcel({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/export-inspection-by-po/`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    async getMaintenanceType({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/pa/maintenance/`, {params: params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getProperties({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/pa/properties/`, {params: params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async loadDataEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/pa/data-entries/`, {params: params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveDataEntries({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/pa/data-entry/`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveInterimReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/pa/adjustment-report`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getCustomEntryHeaderID({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/data-entry-header/${params.id}`,{
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    // data entry header rates of deduction
    async getEntryHeaderRatesOfDeduction({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/pa/data-rates-of-deduction`, {params: params})
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async saveDataEntriesRatesOfDeduction({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();

            formData.append("month", params.month);
            formData.append("year", params.year);
            formData.append("contract_id", params.contract_id || '' );
            formData.append("property_type", params.property_type || '' );
            formData.append("location_id", params.location_id || '' );
            
            if(params.attachments && params.attachments.length > 0) {
                for( var i = 0; i < params.attachments.length; i++ ){
                    let file = params.attachments[i];
                    formData.append('attachments[' + i + ']', file);
                    formData.append('attachments_titles[' + i + ']', file.image_file_title || '');
                }
            }
            
            if(params.delete_atch_ids && params.delete_atch_ids.length > 0){
                for( var j = 0; j < params.delete_atch_ids.length; j++ ){
                    let photoD = params.delete_atch_ids[j];
                    formData.append('delete_atch_ids[' + j + ']', photoD);
                }
            }

            if(params.items && params.items.length > 0){
                for( var i = 0; i < params.items.length; i++ ){
                    let items = params.items[i];
                    formData.append('items['+ i +'][rates_of_deduction_setting_id]', items.rates_of_deduction_setting_id);
                    formData.append('items['+ i +'][quantity]', items.quantity);
                    formData.append('items['+ i +'][rates]', items.rates);
                    formData.append('items['+ i +'][total]', items.total);
                    formData.append('items['+ i +'][description]', items.description);
                    formData.append('items['+ i +'][unit]', items.unit);
                    formData.append('items['+ i +'][id]', items.id || '');
                    formData.append('items['+ i +'][ld_id]', items.ld_id || '');
                    formData.append('items['+ i +'][ld_date]', items.ld_date || '');
                    formData.append('items['+ i +'][property_id]', items.property_id || '');
                    formData.append('items['+ i +'][user_id]', items.user_id || '');
                    formData.append('items['+ i +'][remarks]', items.remarks || '');
                }
            }

            global.axios.post(`/api/pa/data-rates-of-deduction-entry`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
    // export excel
    async exportInterimReportPerLocationExcel({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/export-interim-per-location`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    async exportRatesOfDeductionExcel({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/export-rates-of-deduction`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    async exportFinalReportExcel({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/pa/export-final-report`, {
                method: "POST",
                responseType: 'blob',
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error)
            });
        });
    },
};

const mutations = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
